import * as paths from './paths';

export const searchValues = [
  {
    title: 'Empréstimos',
    path: paths.EMPRESTIMOS,
    id: ['simular_emprestimo', 'contratos_aberto'],
  },
  {
    title: 'Meus dados',
    path: paths.MEUS_DADOS,
    id: [],
  },
  {
    title: 'Requerimentos',
    path: paths.REQUERIMENTOS,
    id: [],
  },
  {
    title: 'Segunda via boleto',
    path: paths.SEGUNDA_VIA_BOLETO,
    id: ['segunda_via_boleto'],
  },
  {
    title: 'Extrato saldo de contas',
    path: paths.EXTRADO_SALDO_CONTAS,
    id: ['extrato_conta_ativo', 'extrato_aposentadoria'],
  },
  {
    title: 'Tabela de contribuição',
    path: paths.TABELA_CONTRIBUICAO,
    id: ['tabela_contribuicao'],
  },
  {
    title: 'Percentual de contribuição',
    path: paths.PERCENTUAL_CONTRIBUICAO,
    id: [],
  },
  {
    title: 'Aporte',
    path: paths.EMISSAO_BOLETO_VOLUNTARIO,
    id: ['aporte'],
  },
  {
    title: 'Beneficios',
    path: paths.BENEFICIOS,
    id: [
      'cpa',
      'transformacao_reserva',
      'saque_vista',
      'reserva_matematica',
      'alterar_recebimento',
      'parcela_adicional',
      'memoria_calculo',
      'informe_rendimento',
      'simular_conversao_beneficio',
      'contracheque',
      'simular_beneficio',
    ],
  },
  {
    title: 'Comunicação plano',
    path: paths.COMUNICACAO_PLANO,
    id: ['comunicacao_plano'],
  },
  {
    title: 'Extrato participante',
    path: paths.EXTRATO_PARTICIPANTE,
    id: ['extrato_cnpc'],
  },
  {
    title: 'Questionário investidor',
    path: paths.QUESTIONARIO,
    id: ['questionario_investidor'],
  },
  {
    title: 'Perfil de investimo',
    path: paths.PERFIL_INVESTIMENTO,
    id: [],
  },
  {
    title: 'Opção instituto',
    path: paths.OPCAO_INSTITUTO,
    id: ['extrato_opcao'],
  },
];
